import React, {Component} from "react";
import { connect } from "react-redux";
import { userActions } from "../../../../actions/user.actions";
import { withNamespaces } from "react-i18next";
import {history} from "../../../../helpers/history";
import UserInfo from "./_components/UserInfo";
import LanguageSwitcher from "./_components/LanguageSwitcher";
import Notification from "./_components/Notification";

class PanelNavbar extends Component {

    componentDidMount() {
        const sidebarCollapse = localStorage.getItem('sidebar-mode');
        const body = document.getElementsByTagName('body')[0];
        if(sidebarCollapse === null)
            localStorage.setItem('sidebar-mode', 'full');

        if(sidebarCollapse === 'full')
            body.classList.remove('sidebar-collapse');

        if(sidebarCollapse === 'nano')
            body.classList.add('sidebar-collapse')
    }

    onClickProfile = (e) => {
        return history.push('/panel/user/profile');
    };

    onClickLogout = (e) => {
        const { dispatch } = this.props;
        dispatch(userActions.logout());
    };

    onClickToggleSidebar = () => {
        localStorage.removeItem('sidebar-mode');
        const body = document.getElementsByTagName('body')[0];
    };

    changeLanguage = (code) => {
        const { i18n } = this.props;
        i18n.changeLanguage(code);
    };

    render() {
        const { t } = this.props;
        const { i18n } = this.props;
        const { user } = this.props;

        return(
            <nav className="main-header navbar navbar-expand navbar-light elevator-4">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <span className="nav-link" data-widget="pushmenu" role="button" onClick={(e) => this.onClickToggleSidebar()}>
                            <i className="fas fa-bars"/>
                        </span>
                    </li>
                </ul>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <Notification/>
                    </li>
                    <li className="nav-item">
                        <UserInfo user={user} goToSettings={this.onClickProfile} logout={this.onClickLogout}/>
                    </li>
                    <li className="nav-item">
                        <LanguageSwitcher changeLanguage={(langCode) => this.changeLanguage(langCode)}/>
                    </li>
                </ul>
            </nav>
        )
    }
}

const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    };
};

export default withNamespaces()(connect(mapStateToProps)(PanelNavbar));
